import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import SwiperCore, { Scrollbar, Autoplay, SwiperOptions, Pagination, Swiper } from 'swiper';
import { ConnectionService } from '@services/connection-service';

@Component({
  selector: 'app-week4-part-one',
  templateUrl: './week4-part-one.component.html',
  styleUrls: ['../../../user/user-view/user-home/user-home.scss'],
  standalone: false,
})
export class Week4PartOneComponent implements OnChanges {
  carouselConfigWeeklyJourney: SwiperOptions = {
    slidesPerView: 'auto',
    navigation: { prevEl: 'nonext', nextEl: 'nonext' },
  };
    @Input('user')user:any;
    @Input('followUp')followUp:any;
    @Output('openInstructions')openInstructions:EventEmitter<string> = new EventEmitter();
    @Output('sendClickEvent') sendClickEvent: EventEmitter<string> = new EventEmitter();

  constructor(private conn: ConnectionService) {
    }
    ngOnChanges(): void {
    }
    handleCTA():void {
    this.sendClickEvent.emit('week_4_result_timeline_header');
      this.conn.navigateToURL('https://app.cureskin.com/article/7T2BaIQHxh');
    }
    handleCardCTA(articleId:string, eventName:string):void {
      this.sendClickEvent.emit(eventName);
      this.conn.navigateToURL(`https://app.cureskin.com/article/${articleId}`);
    }
}
